 <template lang="pug">
  app-modal(
    :modalNova="true",
    :closeOutside="false",
    :titulo="titulo",
    :width="600",
    @closeModal="closeModal()"
    )
    template(slot="body")
      .container-imagem-assinatura
        img(src="@/assets/images/assinatura.png",
          alt="assinatura"
          width="268px"
          height="200px"
        )
      p {{texto}}
      .form-assinatura
        validation-observer(ref="observer")
          validation-provider(rules="required", v-slot="{ errors }")
            app-label(label="Senha:",:required="true")
            el-input.input(
              v-model="assinatura"
              :class="{'erro' : errors.length}"
              type="password"
              @keyup.native.enter="confirmarAssinatura"
            )
            br
            span.help.erro {{ errors[0] }}
    template(slot="footer")
      div.buttons
        el-button(
          type="primary",
          key="botao-confirma",
          :disabled="!assinatura"
          @click="confirmarAssinatura()"
        ) Finalizar
</template>
<script>
import AppModal from '@/components/AppModal'
import AppLabel from '@/components/AppLabel'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {
  data () {
    return {
      assinatura: null
    }
  },

  props: ['titulo', 'texto'],

  mixins: [
    AppNotificacao
  ],

  methods: {
    closeModal () {
      this.$emit('closeModal')
    },

    callbackSucesso (assinatura) {
      this.$emit('callbackSucesso', assinatura)
    },

    async confirmarAssinatura () {
      const valido = await this.$refs.observer.validate()

      if (valido) {
        this.callbackSucesso(this.assinatura)
      }
    }
  },
  components: {
    AppModal,
    AppLabel
  }
}

</script>

<style lang="scss" scoped>
@import "@/assets/styles/element-variables.scss";

.container-imagem-assinatura {
  display: flex;
  width: 100%;
  justify-content: center;
  margin-bottom: 20px;
}

.form-assinatura {
  margin-top: 50px;
}

.buttons {
  display: flex;
  justify-content: flex-end;
  padding-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/ModalAssinatura.vue